import { render, staticRenderFns } from "./AddTransformWizardDialog.vue?vue&type=template&id=0fe5cc46&"
import script from "./AddTransformWizardDialog.vue?vue&type=script&lang=js&"
export * from "./AddTransformWizardDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddTransformWizardDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports